if (!customElements.get('card-swatches')) {
  customElements.define(
    'card-swatches',
    class CardSwatches extends HTMLElement {
      static widths = [165, 360, 533, 720, 940, 1066];

      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.addEventListener('click', this.onClick);
      }

      onClick(event) {
        const swatch = event.target.closest('.card__swatch');
        if (!swatch || swatch.classList.contains('card__swatch--selected')) return;

        event.preventDefault();
        this.select(swatch);
      }

      select(swatch) {
        this.querySelectorAll('.card__swatch').forEach((element) => {
          const isSelected = element === swatch;
          element.classList.toggle('card__swatch--selected', isSelected);
          element.setAttribute('aria-pressed', isSelected);
        });

        const card = this.closest('.card-wrapper');
        if (!card) return;

        const images = card.querySelectorAll('.card__media img');
        const primary = swatch.dataset.mediaSrc;
        if (images[0] && primary) {
          this.setImage(images[0], primary, swatch.dataset.mediaWidth, swatch.dataset.mediaHeight, swatch.dataset.mediaAlt);
        }

        // Fall back to the primary image so hovering never reveals another color.
        if (images[1] && primary) {
          const secondary = swatch.dataset.secondarySrc || primary;
          const useSecondary = Boolean(swatch.dataset.secondarySrc);
          this.setImage(
            images[1],
            secondary,
            useSecondary ? swatch.dataset.secondaryWidth : swatch.dataset.mediaWidth,
            useSecondary ? swatch.dataset.secondaryHeight : swatch.dataset.mediaHeight,
            useSecondary ? swatch.dataset.secondaryAlt : swatch.dataset.mediaAlt
          );
        }

        // Point the card — and quick add — at the color that is now showing.
        const url = swatch.dataset.variantUrl;
        if (url) {
          card.querySelectorAll('a.full-unstyled-link').forEach((link) => link.setAttribute('href', url));
          card.querySelectorAll('[data-product-url]').forEach((element) => element.setAttribute('data-product-url', url));
        }
      }

      setImage(image, url, width, height, alt) {
        const maxWidth = parseInt(width, 10);
        const separator = url.includes('?') ? '&' : '?';
        const sources = CardSwatches.widths
          .filter((size) => !maxWidth || size <= maxWidth)
          .map((size) => `${url}${separator}width=${size} ${size}w`);

        if (maxWidth) sources.push(`${url} ${maxWidth}w`);

        image.srcset = sources.join(', ');
        image.src = `${url}${separator}width=533`;
        if (maxWidth) image.width = maxWidth;
        if (height) image.height = parseInt(height, 10);
        image.alt = alt || '';
      }
    }
  );
}
